// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_feedbackScreen__NSN7W {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: white; }

.styles_container__q5N-T {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 36rem;
  padding: 3rem;
  background-color: white;
  border-radius: 0.75rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.05);
  text-align: center; }

.styles_iconContainer__YkFN5 {
  margin-bottom: 1.5rem; }

.styles_friendlyIcon__QLpkN {
  font-size: 4rem;
  line-height: 1; }

.styles_loader__TxAA9 {
  width: 3rem;
  height: 3rem; }

.styles_content__p2ixh {
  margin-bottom: 2rem; }

.styles_title__yko0Y {
  margin-bottom: 1.5rem;
  font-size: 1.875rem;
  font-weight: 600;
  color: #2d3748; }

.styles_message__LSGW0 {
  margin-bottom: 1.5rem;
  font-size: 1.125rem;
  line-height: 1.6;
  color: #4a5568; }

.styles_subMessage__fsA-m {
  font-size: 1.25rem;
  font-weight: 500;
  color: #2d3748; }

.styles_buttonContainer__\\+\\+7pT {
  display: flex;
  gap: 1rem;
  width: 100%; }
  .styles_buttonContainer__\\+\\+7pT.styles_loading__c5KnB {
    opacity: 0.7; }

.styles_confirmButton__8vPhp {
  flex: 1 1;
  padding: 1rem 2rem;
  border: none;
  border-radius: 1.5rem;
  font-size: 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease; }
  .styles_confirmButton__8vPhp:disabled {
    cursor: not-allowed;
    opacity: 0.6; }

.styles_backButton__p9JPg {
  flex: 1 1;
  padding: 1rem 2rem;
  border: 0.125rem solid #e2e8f0;
  border-radius: 1.5rem;
  font-size: 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 3rem;
  height: 5rem; }
  .styles_backButton__p9JPg:disabled {
    cursor: not-allowed;
    opacity: 0.6; }

@media (max-width: 768px) {
  .styles_container__q5N-T {
    max-width: 90%;
    padding: 1.5rem; }
  .styles_buttonContainer__\\+\\+7pT {
    flex-direction: column; }
  .styles_confirmButton__8vPhp,
  .styles_backButton__p9JPg {
    flex: none; } }
`, "",{"version":3,"sources":["webpack://./src/modules/releases/components/screens/FeedbackScreen/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB,EAAA;;AAGzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kDAAkD;EAClD,kBAAkB,EAAA;;AAGpB;EACE,qBAAqB,EAAA;;AAGvB;EACE,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,mBAAmB,EAAA;;AAGrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,SAAS;EACT,WAAW,EAAA;EAHb;IAMI,YAAY,EAAA;;AAIhB;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC,EAAA;EARxC;IAWI,mBAAmB;IACnB,YAAY,EAAA;;AAIhB;EACE,SAAO;EACP,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,YAAY,EAAA;EAVd;IAaI,mBAAmB;IACnB,YAAY,EAAA;;AAIhB;EACE;IACE,cAAc;IACd,eAAe,EAAA;EAGjB;IACE,sBAAsB,EAAA;EAGxB;;IAEE,UAAU,EAAA,EACX","sourcesContent":[".feedbackScreen {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background-color: white;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 36rem;\n  padding: 3rem;\n  background-color: white;\n  border-radius: 0.75rem;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.05);\n  text-align: center;\n}\n\n.iconContainer {\n  margin-bottom: 1.5rem;\n}\n\n.friendlyIcon {\n  font-size: 4rem;\n  line-height: 1;\n}\n\n.loader {\n  width: 3rem;\n  height: 3rem;\n}\n\n.content {\n  margin-bottom: 2rem;\n}\n\n.title {\n  margin-bottom: 1.5rem;\n  font-size: 1.875rem;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.message {\n  margin-bottom: 1.5rem;\n  font-size: 1.125rem;\n  line-height: 1.6;\n  color: #4a5568;\n}\n\n.subMessage {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #2d3748;\n}\n\n.buttonContainer {\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n  \n  &.loading {\n    opacity: 0.7;\n  }\n}\n\n.confirmButton {\n  flex: 1;\n  padding: 1rem 2rem;\n  border: none;\n  border-radius: 1.5rem;\n  font-size: 1.5rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  \n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n.backButton {\n  flex: 1;\n  padding: 1rem 2rem;\n  border: 0.125rem solid #e2e8f0;\n  border-radius: 1.5rem;\n  font-size: 1.5rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: 3rem;\n  height: 5rem;\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    max-width: 90%;\n    padding: 1.5rem;\n  }\n  \n  .buttonContainer {\n    flex-direction: column;\n  }\n  \n  .confirmButton,\n  .backButton {\n    flex: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"feedbackScreen": `styles_feedbackScreen__NSN7W`,
	"container": `styles_container__q5N-T`,
	"iconContainer": `styles_iconContainer__YkFN5`,
	"friendlyIcon": `styles_friendlyIcon__QLpkN`,
	"loader": `styles_loader__TxAA9`,
	"content": `styles_content__p2ixh`,
	"title": `styles_title__yko0Y`,
	"message": `styles_message__LSGW0`,
	"subMessage": `styles_subMessage__fsA-m`,
	"buttonContainer": `styles_buttonContainer__++7pT`,
	"loading": `styles_loading__c5KnB`,
	"confirmButton": `styles_confirmButton__8vPhp`,
	"backButton": `styles_backButton__p9JPg`
};
export default ___CSS_LOADER_EXPORT___;
